import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// React Router doesn't reproduce the browser's native full-page-load
// scroll behavior, since it never actually reloads the page: a plain
// route change (e.g. a footer "Quick Links" entry) leaves the scroll
// position wherever it was, and a #anchor link just updates the URL
// without jumping to the element. This restores both behaviors.
const ScrollToHash = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      return;
    }

    const id = location.hash.slice(1);

    const scrollToElement = () => {
      const el = document.getElementById(id);
      if (!el) return false;

      const navbar = document.querySelector('.navbar');
      const offset = (navbar ? navbar.getBoundingClientRect().height : 0) + 20;
      const top = el.getBoundingClientRect().top + window.pageYOffset - offset;

      window.scrollTo({ top, behavior: 'smooth' });
      return true;
    };

    if (!scrollToElement()) {
      // Target page may still be mounting (navigating from another route) — retry shortly.
      const timer = setTimeout(scrollToElement, 100);
      return () => clearTimeout(timer);
    }
  }, [location]);

  return null;
};

export default ScrollToHash;
